<template>
    <div style="height:120px; width:100%"  class="ml-3 mt-2">
        <div v-if="hasNoStudentSelected() && customer.length > 0" class="alert alert-danger mt-1">Please select a student for all products before checkout</div>
        <hr>
            <table style="width:100%">
            <tr>
                <td>Total Sales Taxable</td>
                <td>{{parseFloat(totalexcl).toFixed(2)}} AED</td>
            </tr>

            <tr v-if="totaldisc !== 0.00">
                <td>Total Discount</td>
                <td>{{ parseFloat(totaldisc).toFixed(2)}} AED</td>
            </tr>

            <tr>
                <td>Vat @5%</td>
                <td>{{ parseFloat(totalvat).toFixed(2)}} AED</td>
            </tr>

            <tr>
                <td>Total</td>
                <td>{{totalprice}} AED</td>
            </tr>

        </table>
        <div class="text-right">
            <div class="row">
                <div class="col-md-6" v-if="carts.length > 0 && customer.length > 0 && (!location_required || (location_required && location.id)) && (!term_required || (term_required && term.drid))">
                    <sub class="text-danger">3rd</sub>
                    <multi-select :options="payments"
                        :selected-options="payment"
                        placeholder="Please select payment method"
                        @select="onSelect"
                        class="payment-dropdown"
                        :dropdown-direction="'up'">
                    </multi-select>
                </div>

                <div class="col-md-6" v-if="payment.length > 0  && customer.length > 0 && carts.length > 0">
                    <sub class="text-danger">4th</sub>
                    <button class="text-center p-3 btn btn-primary" style="border-radius: 10px" data-toggle="modal" @click="checkout" data-target="#checkout">
                    checkout
                    </button>

                        <div class="modal fade" id="checkout" tabindex="-1" role="dialog" aria-labelledby="ModalLabel" aria-hidden="true">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="checkout">Checkout</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>

                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-md-12">

                                                <Checkout :carts="carts" :tax_vat="tax_vat" :tax_vat_one="tax_vat_one" :payments="payment" :settings="settings" :location="location" :term="term" />

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { MultiSelect } from 'vue-search-select'
import Checkout from './Checkout.vue'
export default {
    components: { MultiSelect,  Checkout},
    //props:['tax_vat_one', 'tax_vat', 'carts', 'customer', 'student', "settings", "location", "location_required", "term", "term_required"],
    props: {
        tax_vat_one: {
            type: Number
        },
        tax_vat: {
            type: Number
        },
        carts: {
            type: Array
        },
        customer: {
            type: Array
        },
        customerStudent: {
            type: Array
        },
        settings: {
            type: Array
        },
        location: {
            type: Object,
            default: null
        },
        location_required: {
            type: Boolean,
            default: false
        },
        term: {
            type: Object,
            default: null
        },
        term_required: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            payment: [],
            lastSelectpayments: {},
            payments: [
                    {
                        value: "cash",
                        text: "Cash",
                        halaga: 0
                     },
                     {
                        value: "card",
                        text: "Card",
                        halaga: 0
                     },
                     {
                        value: "credit",
                        text: "Credit",
                        halaga: 0
                    },
                    {
                        value: "bank",
                        text: "Bank Transfer",
                        halaga: 0
                    },
                    {
                        value: "cheque",
                        text: "Cheque",
                        halaga: 0
                    },
                    {
                        value: "telr",
                        text: "Telr",
                        halaga: 0
                    },
                    {
                        value: "magnati",
                        text: "Magnati",
                        halaga: 0
                    }
                ],

        }
    },
    methods: {
        checkout(){
                let payment = JSON.stringify(this.payment);
                localStorage.setItem('payment', payment);
        },
        onSelect (items, lastSelectItem) {
            this.payment = items
            this.lastSelectpayments = lastSelectItem
        },
        hasNoStudentSelected(){
            const hasNoStudent = this.carts.find(cart => cart.student === "");
            return !!hasNoStudent;
        },
        mounted() {
            // Force dropdown to open upwards
            this.$nextTick(() => {
                const dropdown = this.$el.querySelector('.payment-dropdown .dropdown-menu');
                if (dropdown) {
                    dropdown.style.top = 'auto';
                    dropdown.style.bottom = '100%';
                    dropdown.style.transform = 'none';
                }
            });
        }
    },
    computed: {
        totalprice() {
            return this.carts.reduce((total, item) => {
                return total + (item.quantity * item.price) - item.discount
            }, 0)
        },
        totalexcl : function() {
                return this.totalprice / this.tax_vat_one
        },
        totalvat : function () {
                return this.totalexcl * this.tax_vat
        },
        totaldisc() {
            return this.carts.reduce((total, item) => {
                return total + Number(item.discount)
            }, 0)
        },
        requireLocation(){
            if(this.location_required === true && !this.location.id){
                return false;
            }
            else if(this.location_required === true && this.location.id){
                return true;
            }
            else if(!this.location_required){
                return true;
            }
        }
    }
}
</script>

<style scoped>
.payment-dropdown {
    position: relative;
}

.payment-dropdown >>> .dropdown-menu {
    position: absolute;
    bottom: 100% !important;
    top: auto !important;
    margin-bottom: 0.125rem;
    transform: none !important;
    will-change: transform;
}

.payment-dropdown >>> .dropdown-menu.show {
    transform: none !important;
}

.payment-dropdown >>> .dropdown-toggle::after {
    display: none;
}
</style>



// WEBPACK FOOTER //
// resources/js/POS/Total.vue